<div class="page-container">
  <div class="container">
    <div id="headerdata" #headerdata>
      <div class="date-container">
        <div class="org-card">
          <div class="carousel-container no-print">
            <img class="gear2" src="assets/images/gear2.svg" alt="" />
            <div class="carousel-images">
              <div class="first-item">
                <img class="gear1" src="assets/images/gear1.svg" alt="" />
                <div class="first-item-content">
                  <p class="nada">NADA</p>
                  <p class="group-id">{{ GroupName }}</p>
                  <p class="group">Group</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p class="OrgName">{{ name }}</p>
            <p class="addres">{{ address }}</p>
          </div>
        </div>
        <div class="right-content">
          <img
            src="/assets/images/print.svg"
            alt="Consultant"
            (click)="printGroupRoaster()"
            class="icon print-icon no-print"
          />
          <p class="date-text">Date: {{ currentDate }}</p>
          <p class="date-text print-only">{{ GroupName }}</p>
        </div>
      </div>

      <div class="contact-card">
        <div class="detail">
          <div class="title">
            <img
              src="/assets/images/consultant.svg"
              alt="Consultant"
              class="icon no-print"
            />
            <p>Consultant:</p>
          </div>
          <p class="value">{{ organization?.consultant || "-" }}</p>
        </div>
        <div class="detail">
          <div class="title">
            <img
              src="/assets/images/phone.svg"
              alt="phone"
              class="icon no-print"
            />
            <p>Phone:</p>
          </div>
          <p class="value">{{ organization?.phoneNumber || "-" }}</p>
        </div>
        <div class="detail">
          <div class="title">
            <img src="/assets/images/fax.svg" alt="fax" class="icon no-print" />
            <p>Fax:</p>
          </div>
          <p class="value">{{ organization?.fax || "-" }}</p>
        </div>
        <div class="detail">
          <div class="title">
            <img
              src="/assets/images/email.svg"
              alt="email"
              class="icon no-print"
            />
            <p>Email:</p>
          </div>
          <p class="value">{{ organization?.email || "-" }}</p>
        </div>
        <div class="detail">
          <div class="title">
            <img
              src="/assets/images/website.svg"
              alt="website"
              class="icon no-print"
            />
            <p>Website:</p>
          </div>
          <p class="value">
            <a [href]="organization?.website" target="_blank">
              {{ organization?.website || "-" }}
            </a>
          </p>
        </div>
      </div>
      <div class="contact-card">
        <div class="detail">
          <div class="title">
            <p>Team Leader:</p>
          </div>
          <p class="value">{{ organization?.teamLeader || "-" }}</p>
        </div>
        <div class="detail">
          <div class="title">
            <p>Phone:</p>
          </div>
          <p class="value">{{ organization?.teamLeadPhoneNumber || "-" }}</p>
        </div>
        <div class="detail">
          <div class="title">
            <p>NADA Toll Free:</p>
          </div>
          <p class="value">{{ organization?.nadaTollFree || "-" }}</p>
        </div>
        <div></div>
        <div class="indicators">
          <p>** Indicates Chairman</p>
          <p>* Indicates Vice Chairman</p>
        </div>
      </div>
    </div>
    @if (showErrorPage) {
      <div class="error-row">
        <app-error-page [statusCode]="statusCode" />
      </div>
    } @else {
      <div class="table-container">
        <table id="tblData" #tblData class="table">
          <thead class="table-head">
            <tr class="header-row">
              <th class="header-cell">Code ID</th>
              <th class="header-cell">
                Nickname <br />
                (spouse)
              </th>
              <th class="header-cell">Dealer's Name <br />Dealership</th>
              <th class="header-cell">Mail Address</th>
              <th class="header-cell">
                Office Phone <br />
                Fax Number
              </th>
              <th class="header-cell">Email Address</th>
            </tr>
          </thead>
          @if (isSpinner) {
            <div class="spinner-row">
              <div class="table-spinner">
                <app-nada-spinner />
              </div>
            </div>
          } @else {
            <tbody class="table-body">
              @for (member of groupRoasterData; track member) {
                <tr class="data-row">
                  <td class="data-cell">
                    <b> {{ member.code }}</b> <br />
                    {{ member.id }}
                  </td>
                  <td class="data-cell">{{ member?.nickName }}</td>
                  <td class="data-cell">
                    {{ member.dealerName }} <br />
                    {{ member.dealership }}
                  </td>
                  <td class="data-cell">
                    {{ member.address }}<br />
                    {{ member.fullAddress }}
                  </td>
                  <td class="data-cell">{{ member?.officePhone }}</td>
                  <td class="data-cell">{{ member?.emailAddress }}</td>
                </tr>
              }
              <tr>
                <td class="data-cell">
                  <b> {{ groupRoasterData.length }}</b> members
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
    }
  </div>
</div>
